import Api from "..";
import TransmedCoordinator, {
  TransmedCoordinatorInput,
  TransmedCoordinatorUpdateInput,
} from "../../dtos/transmed/process/coordinator";
import transform from "../../service/transform";

export default class TransmedCoordinatorApi extends Api {
  constructor() {
    super("transmed/coordinator");
  }

  public async get(): Promise<TransmedCoordinator[]> {
    const data = (await super.get()).data;    
    if (!Array.isArray(data))
      throw new TypeError("TransmedCoordinator entry list is not an array.");

    return await Promise.all(
      data.map(async (value) => await transform(TransmedCoordinator)(value))
    );
  }

  public async post(data: TransmedCoordinatorInput): Promise<TransmedCoordinator> {
    return await transform(TransmedCoordinator)((await super.post(data)).data);
  }

  public async put(
    id: string,
    data: TransmedCoordinatorUpdateInput
  ): Promise<TransmedCoordinator> {
    return await transform(TransmedCoordinator)((await super.put(id, data)).data);
  }

  public async delete(id: string): Promise<void> {
    await super.delete(id);
  }
}
